<template>
    <div class="col-12 mx-auto">
        <div class="justify-content-between row">
            <div class="text-left mt-3 col-4" />
            <div>
                <h2>{{ $t("registers.events.evaluation.tempRanking.rejected") }}</h2>
            </div>
            <div class="text-right mt-3 col-4">
                <i class="fas fa-cogs pointer fa-2x text-primary"
                    v-if="showSettingsBtn"
                    @click.stop="changeGridSettings"
                    data-toggle="tooltip"
                    :title="$t('buttons.settings.tooltipText')"></i>
            </div>
        </div>

        <div v-if="showUserSettingsForm">
            <grid-user-settings
                ref="userSettings"
                :schemaModelFields="rejectedSchemaModel"
                :componentName="componentName"
                :useLabelAsTitle="true"
                :showUserSettings="true"
                :gridOptions="userSettings"
                @saveGridSettings="saveGridSettings"
                @loadGridSettings="loadGridSettings"
                @userSettingsChanged="userSettingsChanged"
                @deleteGridSettings="deleteGridSettings"
            />
        </div>

        <kendo-datasource ref="rejectedDataSource"
                          :transport="rejectedTransportSettings"
                          :schema-model-id="'id'"
                          :schema-model-fields="rejectedSchemaModel"
                          :schema-total="'total'"
                          :schema-data="'data'"
                          :page-size='gridOptions.pageable.size'
                          :server-paging="false"
                          :server-sorting="false"
                          :server-filtering="false"
                          :error="dataSourceError"
                          :requestEnd="datasorceRequestEnd">
        </kendo-datasource>

        <kendo-grid ref="rejectedGrid"
                    :data-source-ref="'rejectedDataSource'"
                    :pageable="gridOptions.pageable"
                    :navigatable="gridOptions.navigatable"
                    :editable="gridOptions.editable"
                    :filterable="gridOptions.filterable"
                    :reorderable="gridOptions.reorderable"
                    :resizable="gridOptions.resizable"
                    :groupable="gridOptions.groupable"
                    :allow-copy="gridOptions.allowCopy"
                    :column-menu="gridOptions.columnMenu"
                    :sortable-mode="gridOptions.sortable.mode"
                    :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                    :sortable-show-indexes="gridOptions.sortable.showIndexes"
                    :selectable="gridOptions.selectable"
                    :scrollable="gridOptions.scrollable"
                    :toolbar="gridOptions.toolbar"
                    :excel="gridOptions.excel"
                    :data-bound="dataBound">
            <!--<kendo-grid-column :field="'id'"
                       :filterable="false"
                       :title="$t('registers.events.participants.gridHeaders.id')"
                       :hidden="true">
    </kendo-grid-column>-->
            <kendo-grid-column :selectable="true" :width="60" :hidden="!showBtns"></kendo-grid-column>
            <kendo-grid-column field="fullName"
                               :title="$t('registers.events.participants.gridHeaders.name')">
            </kendo-grid-column>
            <kendo-grid-column field="fullNameTransliterated"
                               :sortable="false"
                               :filterable="false"
                               :title="$t('registers.events.participants.gridHeaders.nameTransliterated')">
            </kendo-grid-column>
            <kendo-grid-column field="email"
                               :title="$t('registers.events.participants.gridHeaders.email')">
            </kendo-grid-column>
            <kendo-grid-column field="position"
                               :title="$t('registers.events.participants.gridHeaders.position')"
                               :hidden="isEnVersion">
            </kendo-grid-column>
            <kendo-grid-column field="positionEn"
                               :title="$t('registers.events.participants.gridHeaders.position')"
                               :hidden="!isEnVersion">
            </kendo-grid-column>
            <kendo-grid-column field="institutionRegister"
                               :title="$t('registers.events.participants.gridHeaders.institutionNomenclature')">
            </kendo-grid-column>
            <kendo-grid-column field="rank"
                               :title="$t('registers.events.participants.gridHeaders.rank')">
            </kendo-grid-column>
            <kendo-grid-column field="score"
                               :title="$t('registers.events.participants.gridHeaders.score')">
            </kendo-grid-column>
            <kendo-grid-column field="isConfirmed"
                               :template="isConfirmedCellTemplate"
                               :title="$t('registers.events.evaluation.tempRanking.isConfirmed')">
            </kendo-grid-column>
            <kendo-grid-column field="isConfirmRejected"
                               :template="isConfirmRejectedCellTemplate"
                               :title="$t('registers.events.evaluation.tempRanking.isConfirmRejected')">
            </kendo-grid-column>
            <kendo-grid-column
                field="rejectionNote"
                :title="$t('registers.events.participants.gridHeaders.rejectionNote')"
            />
            <kendo-grid-column field="accommodationRequired"
                               :template="accommodationRequiredCellTemplate"
                               :title="$t('participationConfirmation.accommodationRequired')">
            </kendo-grid-column>
            <kendo-grid-column field="isManuallyAdded"
                               :template="isManuallyAddedellTemplate"
                               :title="$t('registers.events.evaluation.tempRanking.isManuallyAdded')">
            </kendo-grid-column>
            <kendo-grid-column field="isParticipant"
                               :template="isParticipantCellTemplate"
                               :title="$t('registers.events.evaluation.tempRanking.isParticipant')">
            </kendo-grid-column>
            <kendo-grid-column v-if="showBtns && hasEditRights"
                                field="btnsColumn"
                               :width="150"
                               :title="$t('registers.events.participants.gridHeaders.management')"
                               :sortable="false"
                               :filterable="false"
                               :template="isLockedForEdit? '':rejectedBtnsTemplate">
            </kendo-grid-column>
        </kendo-grid>

        <AccommodationRequestDetailsModal v-model="accommodationRequestModel" :show="showDetails" @onClose="onAccommodationDetailsClose">
        </AccommodationRequestDetailsModal>

        <JsonFormatter v-model="rankingDetails" :show.sync="showRankingDetails"
                       :titleKey="'buttons.details.btnText'"
                       @onClose="onRankingDetailsClose">
        </JsonFormatter>

        <EditModal v-model="candidateModel" :show="showEditModal" @onEdit="onEdit" @onClose="onEditClose"></EditModal>
    </div>
</template>
<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import BtnsTemplate from '@/components/grid/StandardBtnsTemplate';
    import GridUserSettings from '@/components/grid/UserSettings';
    import AccommodationRequestDetailsModal from '@/components/dynamic/events/accommodationRequest/details.modal';
    import { EventClaims } from '@/models/enums';
    import { mapGetters } from 'vuex'
    import JsonFormatter from '@/components/common/json.formatter.modal.vue';
    import tempRankingService from '@/services/tempRanking.service';
    import personalizationService from '@/services/personalization.service';
    import EditModal from './edit.modal';

    export default {
        name: 'RejectedRankingGrid',
        components: {
            AccommodationRequestDetailsModal,
            JsonFormatter,
            EditModal,
            GridUserSettings
        },
        props: {
            tempRankingId: {
                type: Number,
                default: 0
            },
            eventId: {
                type: Number,
                default: 0
            },
            details: {
                type: Boolean,
                default: false
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            },
            componentName: {
                default: "RejectedGridForEvent",
                type: String,
            },
            showSettingsBtn: {
                default: true,
                type: Boolean,
            }
        },
        created: function () {
            window.JSZip = JSZip
        },
        data() {
            return {
                tempRankId: this.tempRankingId,
                showDetails: false,
                accommodationRequestModel: null,
                showUserSettingsForm: false,
                customSettingsLoaded: false,
                rejectedSchemaModel: {
                    id: { name: 'id', from: 'id', type: 'number', nullable: false },
                    fullName: { name: 'fullName', from: 'fullName', type: 'string', nullable: true },
                    fullNameTransliterated: { name: 'fullNameTransliterated', from: 'fullNameTransliterated', type: 'string', nullable: true },
                    email: { name: 'email', from: 'email', type: 'string', nullable: true },
                    position: { name: 'position', from: 'position', type: 'string', nullable: true },
                    positionEn: { name: 'positionEn', from: 'positionEn', type: 'string', nullable: true },
                    institutionNomenclature: {
                        name: 'institutionNomenclature',
                        from: 'institutionNomenclature',
                        type: 'string',
                        nullable: true
                    },
                    institutionNomenclatureEn: {
                        name: 'institutionNomenclatureEn',
                        from: 'institutionNomenclatureEn',
                        type: 'string',
                        nullable: true
                    },
                    institutionRegister: {
                        name: 'institutionRegister',
                        from: 'institutionRegister',
                        type: 'string',
                        nullable: true
                    },
                    accommodationRequired: {
                        name: 'accommodationRequired',
                        from: 'accommodationRequired',
                        type: 'boolean',
                        nullable: true
                    },
                    participationDetailsId: {
                        name: 'participationDetailsId',
                        from: 'participationDetailsId',
                        type: 'number',
                        nullable: true
                    },
                    isManuallyAdded: { name: 'isManuallyAdded', from: 'isManuallyAdded', type: 'boolean', nullable: true },
                    isParticipant: { name: 'isParticipant', from: 'isParticipant', type: 'boolean', nullable: true },
                    hasChanges: {
                        name: "hasChanges",
                        from: "hasChanges",
                        type: "boolean",
                        nullable: true,
                    },
                    rejectionNote: {
                        name: "rejectionNote",
                        from: "rejectionNote",
                        type: "string",
                        nullable: true,
                    },
                },
                rejectedTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/tempRanking/listRejected`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                rankingDetails: '',
                showRankingDetails: false,
                showEditModal: false,
                candidateModel: null,
                gridOptions: {
                ...this.$store.getters.gridOptions,
                toolbar: this.showBtns
                    ? [
                            {
                                name: 'NotifySelectedParticipants',
                                template: this.toolbarNotifySelectedTemplate,
                            },
                            {
                                name: 'excel',
                                text: this.$t("buttons.excelExport.tooltipText"),
                            }
                        ]
                    : [
                            {
                                name: 'excel',
                                text: this.$t("buttons.excelExport.tooltipText"),
                            }
                    ],
                excel: {
                    fileName: 'RejectedList.xlsx',
                    allPages: false,
                    filterable: true,
                    collapsible: true
                },
            },
            }
        },
        beforeDestroy() {
            $('#notifySelectedRejectedBtn').off('click');
        },
        mounted() {
            this.setListeners();
        },
        computed: {
            ...mapGetters(['claims', 'isEnVersion']),
            token: function () {
                return this.$store.getters.authToken;
            },
            hasEditRights() {
                const claim = this.$store.getters.eventClaims[EventClaims.TempRanking];
                const canEdit = this.haveClaimWritePermisions(claim);
                return canEdit;
            },
            userSettings() {
                let grid = this.$refs.rejectedGrid.kendoWidget();
                return grid.getOptions();
            },
        },
        methods: {
            setListeners() {
                const self = this;
                $('#notifySelectedRejectedBtn').on('click', (e) => {
                    e.preventDefault();

                    if (self.hasEditRights) {
                        kendo.confirm(`${self.$t('registers.events.evaluation.tempRanking.notifiedSelectedAdmitted')}`)
                        .done(() => {
                            const grid = self.$refs.rejectedGrid.kendoWidget();
                            if (grid) {
                                self.notifySelected(grid);
                            }
                        });
                    }
                });
            },
            dataBound(e) {
                var items = e.sender.items();
                items.each(function (idx, item) {
                    let dataItem = e.sender.dataItem(item);
                    if (dataItem.hasChanges === true) {
                        $(item).addClass("left-border-danger");
                    } else if (dataItem.isManuallyAdded === true) {
                        $(item).addClass("left-border-info");
                    } else if (dataItem.isParticipant === true) {
                        $(item).addClass('left-border-green');
                    }
                });

                if (this.showSettingsBtn) {
                    if (!this.customSettingsLoaded) {
                        this.loadGridSettings();
                        this.customSettingsLoaded = true;
                    }
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    let newOptions = { id: this.tempRankId, eventId: this.eventId, request: options };
                    return kendo.stringify(newOptions);
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            datasorceRequestEnd(e) {
                if (e.type === "read" && e.response) {
                    let count = Number(e.response.total);
                    if (!isNaN(count)) {
                        this.$emit("rejectedCount", count);
                    }
                }
            },
            getGridOptions() {
                const grid = this.$refs.rejectedGrid.kendoWidget();
                if (grid) {
                    return grid.getOptions();
                }
            },
            saveGridSettings() {
                const gridSettings = this.getGridOptions();
                const grid = this.$refs.rejectedGrid.kendoWidget();

                if (gridSettings && grid) {
                    if (!gridSettings.loadedUserSettings) {
                        gridSettings.loadedUserSettings = true;
                    }

                    this.$refs.userSettings.setGridSettings(gridSettings);

                    personalizationService
                        .saveGridSettings(this.componentName, gridSettings)
                        .then((response) => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                text: this.$helpers.responseMessage(response),
                                color: 'success',
                                time: this.$store.getters.notificationDuration,
                            });
                        })
                        .catch((error) => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: this.$helpers.errorColor(error),
                                time: this.$store.getters.notificationDuration,
                            });
                        })
                        .finally(() => {
                            this.setListeners();
                        });
                }
            },
            loadGridSettings() {
                personalizationService
                    .loadGridSettings(this.componentName)
                    .then((response) => {
                        try {
                            const gridOptionsBeforeMerge = this.getGridOptions();
                            var options = personalizationService.mergePersonGridSettings(
                                gridOptionsBeforeMerge,
                                response.data.settings
                            );

                            let grid = this.$refs.rejectedGrid.kendoWidget();
                            if (options && grid) {
                                let isConfirmedColumn = options.columns.find(
                                    (col) => col.field === "isConfirmed"
                                );
                                if (isConfirmedColumn) {
                                    isConfirmedColumn.template = this.isConfirmedCellTemplate;
                                }

                                let isConfirmRejectedColumn = options.columns.find(
                                    (col) => col.field === "isConfirmRejected"
                                );
                                if (isConfirmRejectedColumn) {
                                    isConfirmRejectedColumn.template = this.isConfirmRejectedCellTemplate;
                                }

                                let accommodationRequiredColumn = options.columns.find(
                                    (col) => col.field === "accommodationRequired"
                                );
                                if (accommodationRequiredColumn) {
                                    accommodationRequiredColumn.template = this.accommodationRequiredCellTemplate;
                                }

                                let isManuallyAddedColumn = options.columns.find(
                                    (col) => col.field === "isManuallyAdded"
                                );
                                if (isManuallyAddedColumn) {
                                    isManuallyAddedColumn.template = this.isManuallyAddedellTemplate;
                                }

                                let isParticipantColumn = options.columns.find(
                                    (col) => col.field === "isParticipant"
                                );
                                if (isParticipantColumn) {
                                    isParticipantColumn.template = this.isParticipantCellTemplate;
                                }

                                options.toolbar = gridOptionsBeforeMerge.toolbar;
                                grid.setOptions(options);
                                this.setListeners();

                                if (options.pageable.size !== grid.dataSource.options.pageSize) {
                                    grid.dataSource.pageSize(options.pageable.size);
                                    grid.refresh();
                                }

                                const userSettingsEditor = this.$refs.userSettings;
                                if (userSettingsEditor) {
                                    userSettingsEditor.setGridSettings(
                                        grid.getOptions()
                                    );
                                }
                            }

                            this.customSettingsLoaded = true;
                        } catch (e) {
                            this.customSettingsLoaded = true;
                        }
                    })
                    .catch((error) => {
                        this.customSettingsLoaded = true;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration,
                        });
                    });
            },
            deleteGridSettings() {
                personalizationService
                    .delteGridSettings(this.componentName)
                    .then((response) => {
                        this.$router.go();
                    })
                    .catch((error) => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration,
                        });
                    });
            },
            userSettingsChanged(userSettings, pageSizeChanged) {
                let grid = this.$refs.rejectedGrid.kendoWidget();
                if (grid) {
                    try {
                        grid.setOptions(userSettings);
                        if (pageSizeChanged === true) {
                            if (userSettings.pageable.size === KendoGridPageSize.All) {
                                grid.dataSource.pageSize(this.$refs["rejectedDataSource"].kendoDataSource.total());
                            } else {
                                grid.dataSource.pageSize(userSettings.pageable.size);
                            }
                            grid.refresh();
                        }
                    } catch (e) {
                    }
                }
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            isConfirmedCellTemplate(dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.isConfirmed ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isConfirmed ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            isConfirmRejectedCellTemplate(dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.isConfirmRejected ? 'badge-danger' : 'badge-light') + '">' + kendo.htmlEncode(dataItem.isConfirmRejected ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            isParticipantCellTemplate(dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.isParticipant ? 'badge-success' : 'badge-light') + '">' + kendo.htmlEncode(dataItem.isParticipant ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            accommodationRequiredCellTemplate(dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.accommodationRequired ? 'badge-success' : 'badge-light') + '">' + kendo.htmlEncode(dataItem.accommodationRequired ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            isManuallyAddedellTemplate(dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.isManuallyAdded ? 'badge-info' : 'badge-light') + '">' + kendo.htmlEncode(dataItem.isManuallyAdded ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            toolbarNotifySelectedTemplate() {
                return `<a role='button' id='notifySelectedRejectedBtn' class='k-button k-button-icontext'>
                        <span class='k-icon k-i-envelop'></span>${this.$t('buttons.notifySelected.btnText')}</a>`;
            },
            refresh() {
                const grid = this.$refs.rejectedGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            rejectedBtnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.lecturersListGrid,
                        btns: [
                            {
                                name: "moveToAdmitted",
                                text: this.$t('buttons.admit.btnText'),
                                tooltip: this.$t('buttons.admit.btnText'),
                                class: 'btn btn-info',
                                icon: "fas fa-angle-right",
                                show: true,
                                clickHandler: this.moveToAdmitted
                            },
                            {
                                name: "moveToReserve",
                                text: this.$t('buttons.reserve.btnText'),
                                tooltip: this.$t('buttons.reserve.btnText'),
                                class: 'btn btn-info',
                                icon: "fas fa-angle-right",
                                show: true,
                                clickHandler: this.moveToReserve
                            },
                            {
                                name: "rankingDetails",
                                text: "",
                                tooltip: this.$t('buttons.rankingDetails.btnText'),
                                class: 'btn btn-info',
                                icon: "fas fa-eye",
                                show: this.claims.tempRanking.read && e.isManuallyAdded === false,
                                clickHandler: this.showRankingDetailsModal
                            },
                            {
                                name: "accommodationRequestDetails",
                                text: "",
                                tooltip: this.$t('buttons.accommodationRequestDetails.btnText'),
                                class: 'btn btn-info',
                                icon: "fas fa-h-square",
                                show: e.participationDetailsId,
                                clickHandler: this.accommodationRequestDetailsBtnsClick
                            },
                            {
                                name: "edit",
                                text: this.$t('buttons.edit.btnText'),
                                tooltip: this.$t('buttons.edit.btnText'),
                                class: 'btn btn-primary',
                                icon: "fas fa-edit",
                                show: this.hasEditRights,
                                clickHandler: this.editBtnClick
                            },
                            {
                                name: "delete",
                                text: this.$t('buttons.delete.btnText'),
                                tooltip: this.$t('buttons.delete.btnText'),
                                class: 'btn btn-info',
                                icon: "fas fa-trash-alt",
                                show: this.hasEditRights,
                                clickHandler: this.deleteBtnClick
                            },
                            {
                                name: "syncWithFormEntityData",
                                text: this.$t("buttons.syncWithFormEntityData.btnText"),
                                tooltip: this.$t("buttons.syncWithFormEntityData.btnText"),
                                class: "btn btn-info",
                                icon: "fas fa-sync",
                                show: this.hasEditRights,
                                clickHandler: this.syncWithFormEntityDataBtnClick,
                            },
                        ]
                    }
                };
            },
            moveToAdmitted(args) {
                kendo.confirm(this.$t('registers.events.evaluation.tempRanking.moveToAdmitted'))
                    .then(function () {
                        this.$http.delete(`/api/tempRanking/moveToAdmitted/${args.id}`).then((response => {
                            this.$emit("moveToAdmitted");
                        })).catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            });
                        });
                    }.bind(this));
            },
            moveToReserve(args) {
                kendo.confirm(this.$t('registers.events.evaluation.tempRanking.moveToReserve'))
                    .then(function () {
                        this.$http.delete(`/api/tempRanking/moveToReserve/${args.id}`).then((response => {
                            this.$emit("moveToReserve");
                        })).catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            });
                        });
                    }.bind(this));
            },
            haveClaimWritePermisions(claim) {
                if (!claim) {
                    return false;
                }

                if (claim.create || claim.update) {
                    return true;
                }

                return false;
            },
            accommodationRequestDetailsBtnsClick(args) {
                this.accommodationRequestModel = args;
                this.showDetails = true
            },
            onAccommodationDetailsClose() {
                this.accommodationRequestModel = null;
                this.showDetails = false
            },
            showRankingDetailsModal(args) {
                this.$http.get(`/api/tempRanking/getPersonRankingResult/${args.id}`)
                    .then(response => {
                        this.rankingDetails = response.data;
                        this.showRankingDetails = true;
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('details'),
                            text: this.$helpers.errorText(error),
                            color: 'error',
                            time: this.$store.getters.notificationDuration,
                        })
                    });
            },
            onRankingDetailsClose() {
                this.rankingDetail = '';
                this.showRankingDetails = false
            },
            setTempRankId(id) {
                this.tempRankId = id;
            },
            editBtnClick(args) {
                if (!this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }
                this.showCandidateEditModal(args.id);
            },
            showCandidateEditModal(id) {
                tempRankingService
                    .getCandidateById(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.candidateModel = model;
                            this.showEditModal = true;
                        } else {
                            this.candidateModel = null;
                            this.showEditModal = false;
                        }
                    })
                    .catch(error => {
                        this.candidateModel = null;
                        this.showEditModal = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onEdit(model) {
                this.candidateModel = null
                this.showEditModal = false;
                this.refresh();
            },
            onEditClose() {
                this.showEditModal = false;
                this.candidateModel = null
            },
            deleteBtnClick(args) {
                if (!this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                kendo.confirm(`${this.$t('registers.events.evaluation.tempRanking.confirmation.delete')} ${args.fullName}?`)
                    .then(function () {
                        this.doDelete(args.id);
                    }.bind(this));
            },
            doDelete(id) {
                tempRankingService
                    .deleteTempRankingCandidate(id)
                    .then((response) => {
                        this.$emit("delete");

                        this.$vs.notify({
                            title: this.$t('buttons.delete.action'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('buttons.delete.action'),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    })
            },
            syncWithFormEntityDataBtnClick(args) {
                kendo
                    .confirm(this.$t('registers.events.evaluation.tempRanking.confirmation.syncWithFormEntityData', { name: args.fullName }))
                    .then(
                        function () {
                            tempRankingService
                                .syncWithFormEntityData(args.id)
                                .then((response) => {
                                    this.$emit("syncWithFormEntityData");

                                    this.$vs.notify({
                                        title: this.$t("buttons.syncWithFormEntityData.btnText"),
                                        text: this.$helpers.responseMessage(response),
                                        color: "success",
                                        time: this.$store.getters
                                            .notificationDuration,
                                    });
                                })
                                .catch((error) => {
                                    this.$vs.notify({
                                        title: this.$t("buttons.syncWithFormEntityData.btnText"),
                                        text: this.$helpers.errorText(error),
                                        color: this.$helpers.errorColor(error),
                                        time: this.$store.getters.notificationDuration,
                                    });
                                });
                        }.bind(this)
                    );
            },
            notifySelected(grid) {
                const selectedIds = this.$helpers.getGridSelectedRowsIds(grid);
                if (!selectedIds || selectedIds.length <= 0) {
                    this.$vs.notify({
                        title: this.$t("buttons.notifySelected.action"),
                        text: this.$t("registers.lecturers.emptySelection"),
                        color: "warning",
                        time: this.$store.getters.notificationDuration,
                    });

                    return;
                }

                tempRankingService
                    .notifySelectedRejected({ eventId: this.$route.params.id, participants: selectedIds })
                    .then((response) => {
                        let statusCode = Number(
                            this.$helpers.responseStatusCode(response)
                        );

                        this.$vs.notify({
                            title: this.$t(
                                "request.response.status." +
                                    this.$helpers.responseStatusCode(response)
                            ),
                            text: this.$helpers.responseMessage(response),
                            color: statusCode === 240 ? "warning" : "success",
                            time: this.$store.getters.notificationDuration,
                        });
                    })
                    .catch((error) => {
                        let statusCode = this.$helpers.errorStatusCode(error);

                        this.$vs.notify({
                            title:
                                this.componentTitle +
                                " - " +
                                this.$t("request.response.status." + statusCode),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration,
                        });
                    });
            },
        }
    }
</script>

<style lang="scss">
tr.left-border-danger {
    &:hover

    {
        color: rgba(255, 0, 0, 0.7) !important;
    }

    td:first-child {
        border-left: 3px solid rgba(255, 0, 0, 0.5) !important;
    }
}

tr.left-border-blue {
    &:hover

    {
        color: #3498db !important;
    }

    td:first-child {
        border-left: 3px solid #3498db !important;
    }
}

tr.left-border-green {
    &:hover

    {
        color: #4caf50 !important;
    }

    td:first-child {
        border-left: 3px solid #4caf50 !important;
    }
}
</style>
